<template>
<div style="padding: 16px;">
      <el-card shadow="hover">
        <el-table
          :data="users"
          @row-click="showUser"
          height="100%"
          style="width: 100%">
          <el-table-column
            :fixed="$mq === 'xs' ? false : 'left'"
            >
            <template slot-scope="scope">
              <el-avatar :size="64" :src="scope.row.image_uri" />
            </template>
          </el-table-column>
          <el-table-column
            label="Name"
            :fixed="$mq === 'xs' ? false : 'left'"
            sortable
            prop="firstName"
            min-width="150">
            <template slot-scope="scope">
              {{scope.row.firstName + ' ' + scope.row.lastName}}
            </template>
          </el-table-column>
          <el-table-column
            prop="un"
            min-width="120"
            label="Username">
          </el-table-column>
          <el-table-column
            label="Class"
            sortable
            prop="level.o_id"
            align="center"
            :filters="levelFilters"
            :filter-method="levelFilter"
            min-width="100"
          >
            <template slot-scope="scope">{{ scope.row.level.name }}</template>
          </el-table-column>
          <el-table-column
            label="Position"
            min-width="100">
            <template slot-scope="scope">
              {{scope.row.primary_position ? scope.row.primary_position.symbol : ''}}
            </template>
          </el-table-column>
          <el-table-column
            prop="major"
            min-width="180"
            label="Major">
          </el-table-column>
          <el-table-column
            prop="school"
            min-width="240"
            label="School">
          </el-table-column>
        </el-table>
      </el-card>
</div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
    data() {
        return {selectedType: 'card'};
    },
    computed: {
        ...mapFields([
            'user',
            'users',
            'levels'
        ]),
        levelFilters() {
            var t = [];
            if (this.levels == null) return t;
            this.levels.map((level) => {
                t.push({text: level.name, value: level.o_id});
            });
            return t;
        }
    },
    mounted() {
        if(this.levels == null)
            this.$store.dispatch('pullLevels');
    },
    methods: {
        formatPhoneNumber(s) {
            var s2 = String(s).replace(/\D/g, '');
            var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
            return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
        },
        levelFilter(value, row) {
            return row.level.o_id === value;
        },
        showUser(user) {
            this.$router.push({
                path: '/home/users/'+user.o_id,
                params: {user_object: user}
            }
            );
        }
    }
}
</script>
